/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';


/**
 * Shortcuts for some events to emit
 */
module.exports = {
    /**
     * Set player viewport to full screen
     */
    PLAYER_SET_FULLSCREEN: 'set:fullscreen',

    /**
     * Set player viewport
     */
    PLAYER_SET_VIEWPORT: 'set:viewport',

    /**
     * Send exit event to player
     */
    PLAYER_SEND_EXIT: 'exit',

    /**
     * System event when app is hide
     */
    CORE_EVENT_HIDE: 'hide',

    /**
     * System events when app is show
     */
    CORE_EVENT_SHOW: 'show',

    /**
     * System event when app is closed
     */
    CORE_EVENT_EXIT: 'exit',

    /**
     * System event when we must play channel by number
     */
    CORE_EVENT_PLAY_CHANNEL: 'play:channel',

    /**
     * User click on right arrow
     */
    RIGHT_ARROW_CLICK: 'right:arrow:click',

    /**
     * User click on left arrow
     */
    LEFT_ARROW_CLICK: 'left:arrow:click'
};
